import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api.js';
import { money } from '../../config/brand.js';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([api.stats(), api.orders()])
      .then(([s, o]) => { setStats(s); setOrders(o.slice(0, 6)); })
      .catch((e) => setError(e.message));
  }, []);

  if (error) return <p className="aerror">{error}</p>;
  if (!stats) return <p className="amuted">Loading</p>;
  const t = stats.totals;
  const maxRev = Math.max(1, ...stats.daily.map((d) => d.revenue));

  return (
    <div>
      <h1 className="atitle">Dashboard</h1>
      <div className="astats">
        <div><span>Revenue</span><strong>{money(t.revenue)}</strong></div>
        <div><span>Orders</span><strong>{t.orders}</strong></div>
        <div><span>Pending orders</span><strong>{t.pending}</strong></div>
        <div><span>Average order</span><strong>{money(t.averageOrder)}</strong></div>
        <div><span>Products</span><strong>{t.products}</strong><small>{t.clothing} clothing, {t.handbags} handbags</small></div>
        <div><span>Customers</span><strong>{t.customers}</strong></div>
      </div>

      <div className="acols">
        <section className="acard">
          <h2>Last 14 days</h2>
          <table className="atable atable--bars">
            <tbody>
              {stats.daily.map((d) => (
                <tr key={d.date}>
                  <td>{d.date.slice(5)}</td>
                  <td className="bar"><i style={{ width: `${(d.revenue / maxRev) * 100}%` }} /></td>
                  <td className="num">{d.orders} / {money(d.revenue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="acard">
          <h2>Low stock</h2>
          {stats.lowStock.length === 0 ? <p className="amuted">Nothing is running low.</p> : (
            <table className="atable">
              <thead><tr><th>Product</th><th>Size</th><th className="num">Left</th></tr></thead>
              <tbody>
                {stats.lowStock.map((l, i) => (
                  <tr key={`${l.id}-${l.size}-${i}`}>
                    <td><Link to={`/admin/products/${l.id}`}>{l.name}</Link></td>
                    <td>{l.size || '-'}</td>
                    <td className="num">{l.stock}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>

        <section className="acard">
          <h2>Top products</h2>
          {stats.topProducts.length === 0 ? <p className="amuted">No sales yet.</p> : (
            <table className="atable">
              <thead><tr><th>Product</th><th className="num">Sold</th><th className="num">Revenue</th></tr></thead>
              <tbody>{stats.topProducts.map((p) => <tr key={p.id}><td>{p.name}</td><td className="num">{p.quantity}</td><td className="num">{money(p.revenue)}</td></tr>)}</tbody>
            </table>
          )}
        </section>

        <section className="acard">
          <h2>Recent orders</h2>
          {orders.length === 0 ? <p className="amuted">No orders yet.</p> : (
            <table className="atable">
              <thead><tr><th>Order</th><th>Customer</th><th>Status</th><th className="num">Total</th></tr></thead>
              <tbody>{orders.map((o) => <tr key={o.id}><td>{o.id}</td><td>{o.customerName}</td><td>{o.status}</td><td className="num">{money(o.total)}</td></tr>)}</tbody>
            </table>
          )}
          <p><Link to="/admin/orders">All orders</Link></p>
        </section>
      </div>
    </div>
  );
}
